import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class KsefDocumentCannotBeWithWstoOssTransaction extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.ksef-document.cannot-be-with-wsto-oss-transaction');
    }
}
